// extracted by mini-css-extract-plugin
export default {"form":"UpdateRiskRegisterForm_form__UCyNB","formActions":"UpdateRiskRegisterForm_formActions__K+r--"};